module.exports = __webpack_public_path__ + "img/goodNews.06c69b22.png";